import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AdminSearchResultsModel } from './admin-search-results.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminSearchService {

  adminSearchUrl = 'dealers/';

  constructor(private readonly http: HttpClient) {
  }

  performSearch(searchParams: any):Observable<AdminSearchResultsModel[]>{
    const headers = new HttpHeaders({'Content-Type': 'application/json'});

    return this.http.get<AdminSearchResultsModel[]>(this.adminSearchUrl, {params: searchParams, headers}).pipe(
      map(response => {
        return response ? (response as any[]).map(element => AdminSearchResultsModel.fromJSON(element)) : null
      })
    );
  }

}
